<app-card [header]=true cardHeaderTitle="{{title}}" cardBodyClasses="pt-0" [cardClasses]="'mt-7'" >
  <ng-container cardBody>
    <app-skeleton-text [count]=4 type="text-and-text" [isLoading]="loading">
      <div *ngIf="bodyList.length > 0; else noData" class="row">

        <div class="col-md-6" *ngFor="let item of bodyList">
          <h5 class="mb-4">{{item.title}}</h5>
          <div class="d-flex mb-7" *ngFor="let data of item.data">
            <label class="w-200 text-gray-400">{{data.label}}</label>
            <div>
              <span class="text-gray-800">: {{data.value}}</span>
            </div>
          </div>
        </div>

      </div>
      <ng-template #noData>
        <div class="col-md-12">
          <label class="text-gray-400">{{emptyStateDetailBody}}</label>
        </div>
      </ng-template>
    </app-skeleton-text>
  </ng-container>
</app-card>
